import { push } from 'connected-react-router';
import { Dispatch } from 'redux';

export const startOnboarding = () => {
  return async (dispatch: Dispatch) => {
    dispatch(push('/brand/setup-account'));
  }
}
